import { useState, useRef } from 'react';

export default function DollarInput({value,onChange,onBlur,style,placeholder,autoFocus,...rest}){
const[display,setDisplay]=useState(()=>{
  if(value==null||value==='')return'';
  const n=parseFloat(value);
  return isFinite(n)?n.toFixed(2):'';
});
const editing=useRef(false);

function handleFocus(e){
  editing.current=true;
  // Show raw number for editing (strip trailing zeros for easier typing)
  const n=parseFloat(display);
  if(isFinite(n))setDisplay(String(n));
  e.target.select();
}

function handleChange(e){
  const raw=e.target.value;
  // Allow only digits, one decimal, optional leading minus
  if(raw!==''&&!/^-?\d*\.?\d*$/.test(raw))return;
  setDisplay(raw);
  const n=parseFloat(raw);
  if(onChange)onChange(isFinite(n)?n:0);
}

function handleBlur(e){
  editing.current=false;
  if(display===''){
    if(onBlur)onBlur(e);
    return;
  }
  const n=parseFloat(display);
  if(isFinite(n)){
    setDisplay(n.toFixed(2));
    if(onChange)onChange(n);
  }
  if(onBlur)onBlur(e);
}

// Sync display when value changes externally (not during editing)
if(!editing.current){
  const expected=value==null||value===''?'':(isFinite(parseFloat(value))?parseFloat(value).toFixed(2):'');
  if(display!==expected)setDisplay(expected);
}

return <input
  type="text"
  inputMode="decimal"
  value={display}
  onChange={handleChange}
  onFocus={handleFocus}
  onBlur={handleBlur}
  placeholder={placeholder||'0.00'}
  autoFocus={autoFocus}
  style={style}
  {...rest}
/>;
}
